var BaseRowView = require('../baseRowView/view');


module.exports = BaseRowView.extend({


    serializeData: function() {

        var cxt = BaseRowView.prototype.serializeData.apply( this, arguments );

        var isPageHierarchy = this.channel.request('state').get('showResultsByPage');

        return _.extend( {}, cxt, {

            isHeaderRow: true,
            rowHeader: isPageHierarchy ? "Pages / Hits" : "Searches / Hits"

        });

    },

    events: _.omit( BaseRowView.prototype.events, 'mouseenter', 'mouseleave' )


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/hitsTableView/bodyRows/headerRow/view.js
 ** module id = 628
 ** module chunks = 0
 **/